import { render, staticRenderFns } from "./BqTemplateHandler.vue?vue&type=template&id=75b46a48&scoped=true&"
import script from "./BqTemplateHandler.vue?vue&type=script&lang=js&"
export * from "./BqTemplateHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b46a48",
  null
  
)

export default component.exports